module.exports = __webpack_public_path__ + "img/logo.fe3a430f.svg";